/**
 * The units a product may actually be ordered in.
 *
 * Every SKU carries two: the base unit it is priced in, and a secondary unit
 * the shop sells it by — bags, coils, cartons. Those two are the only ones
 * with a conversion behind them, so they are the only ones that can be turned
 * into a weight and charged for.
 *
 * The screens used to offer a fixed list of ten. Picking one of the other
 * eight left the line with a quantity nothing could convert, which priced it
 * at ₹0 — a silent wrong answer rather than a refusal.
 */
export function unitsFor(product, current) {
  if (!product) return []
  const out = []
  const add = (u) => {
    const code = String(u ?? '').toUpperCase()
    if (code && !out.includes(code)) out.push(code)
  }
  add(product.base_unit)
  add(product.secondary_unit)
  // Whatever the line already says, last. A line read from 'ரெண்டு டன்' sits
  // in TON whether or not the SKU names TON as its secondary unit, and a
  // select whose value is not among its options shows the wrong thing and
  // silently rewrites the line on the next save.
  add(current)
  return out
}

/** 'KILOGRAMS' -> 'kilograms', for a dropdown row. */
export const unitName = (code) => String(code ?? '').toLowerCase()
